var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeOff2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Outline/eye-off-2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8091 13.395C19.5141 11.978 20.6991 9.95301 20.9921 7.62401C21.0611 7.07701 20.6731 6.57701 20.1241 6.50801C19.5841 6.43401 19.0761 6.82701 19.0081 7.37501C18.5691 10.867 15.5561 13.5 12.0001 13.5C8.4441 13.5 5.4311 10.867 4.9921 7.37501C4.9241 6.82701 4.4141 6.43801 3.8751 6.50801C3.3271 6.57701 2.9391 7.07701 3.0081 7.62401C3.3011 9.95301 4.4861 11.978 6.1911 13.395L3.8791 15.707C3.4901 16.096 3.4901 16.732 3.8791 17.121C4.2671 17.51 4.9041 17.51 5.2931 17.121L7.8961 14.518C8.8501 15 9.8971 15.318 11.0001 15.439V19C11.0001 19.55 11.4501 20 12.0001 20C12.5501 20 13.0001 19.55 13.0001 19V15.439C14.1021 15.318 15.1501 15 16.1031 14.518L18.7071 17.121C19.0961 17.51 19.7321 17.51 20.1211 17.121C20.5101 16.732 20.5101 16.096 20.1211 15.707L17.8091 13.395Z",
    fill: "#0C2551"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1014",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 6,
    width: 18,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8091 13.395C19.5141 11.978 20.6991 9.95301 20.9921 7.62401C21.0611 7.07701 20.6731 6.57701 20.1241 6.50801C19.5841 6.43401 19.0761 6.82701 19.0081 7.37501C18.5691 10.867 15.5561 13.5 12.0001 13.5C8.4441 13.5 5.4311 10.867 4.9921 7.37501C4.9241 6.82701 4.4141 6.43801 3.8751 6.50801C3.3271 6.57701 2.9391 7.07701 3.0081 7.62401C3.3011 9.95301 4.4861 11.978 6.1911 13.395L3.8791 15.707C3.4901 16.096 3.4901 16.732 3.8791 17.121C4.2671 17.51 4.9041 17.51 5.2931 17.121L7.8961 14.518C8.8501 15 9.8971 15.318 11.0001 15.439V19C11.0001 19.55 11.4501 20 12.0001 20C12.5501 20 13.0001 19.55 13.0001 19V15.439C14.1021 15.318 15.1501 15 16.1031 14.518L18.7071 17.121C19.0961 17.51 19.7321 17.51 20.1211 17.121C20.5101 16.732 20.5101 16.096 20.1211 15.707L17.8091 13.395Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x8E\xA8 Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    width: 24,
    height: 24,
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff2);
export default __webpack_public_path__ + "static/media/eye-off-2.ef5c1c851a5ac84bd6336c656a7f3b97.svg";
export { ForwardRef as ReactComponent };